import React from 'react';
import OnetLogo from '@/components/Icon/svgs/OnetLogo';

export interface OnetDisclaimerProps {
  className?: string;
  displayOnetData?: boolean;
}

const OnetDisclaimer: React.FC<OnetDisclaimerProps> = ({
  className = '',
  displayOnetData = true,
}) => {
  const timelineDisclaimer = (
    <div>
      Note: Timeline estimates are based on average credit requirements and
      academic calendars. These results are closely related to your search and
      based on semester timelines. We also have partners with more flexible
      academic calendars for you to explore.
    </div>
  );
  return (
    <div className={`bg-primary-25 p-6 rounded-lg ${className}`}>
      {displayOnetData ? (
        <div className='flex flex-col md:flex-row items-center gap-4'>
          <div className='flex-shrink-0'>
            <OnetLogo />
          </div>

          <div className='flex-1 text-gray-800 text-sm leading-relaxed font-normal'>
            <p>
              This page includes information from the{' '}
              <a
                href='https://www.onetcenter.org/database.html'
                target='_blank'
                rel='noopener noreferrer'
                className='underline text-blue-800 hover:text-blue-600'
              >
                O<span className='inline-block -mt-2 text-sm'>*</span>NET 29.3
                Database
              </a>{' '}
              by the U.S. Department of Labor, Employment and Training
              Administration (USDOL/ETA). Used under the{' '}
              <a
                href='https://creativecommons.org/licenses/by/4.0/'
                target='_blank'
                rel='noopener noreferrer'
                className='underline text-blue-800 hover:text-blue-600'
              >
                CC BY 4.0 license
              </a>
              .
            </p>
            <p>
              <span className='text-blue-800 font-bold'>
                O<span className='inline-block -mt-2 text-sm'>*</span>NET®
              </span>{' '}
              is a trademark of USDOL/ETA.
            </p>
          </div>
        </div>
      ) : (
        timelineDisclaimer
      )}
    </div>
  );
};

export default OnetDisclaimer;
